// Human-facing name for a project: the operator's friendly name when set, else
// the linked site's name, else the project_id for legacy rows with no name.
// Mirrors DBProject.display_name.
interface NamedProject {
  name?: string | null;
  friendly_name?: string | null;
  project_id: string;
}

export const projectDisplayName = (p: NamedProject): string =>
  p.friendly_name?.trim() || p.name?.trim() || p.project_id;

// What a search matches: both names, since an operator may type either.
export const projectSearchName = (p: NamedProject): string =>
  [projectDisplayName(p), p.friendly_name ? p.name : null]
    .filter(Boolean)
    .join(" ");
